<template>
  <ObjectLoader v-if="value === undefined" />
  <NotFound v-else-if="value === null && id" />
  <div v-else class="loaded" @contextmenu.prevent>
    <slot />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRefs, watch } from "vue";

import * as inject from "@/components/inject";
import NotFound from "@/components/NotFound.vue";
import ObjectLoader from "@/components/ObjectLoader.vue";
import { RouteNames } from "@/routes/types";
import { navigateTo } from "@/utils/navigate";

export default defineComponent({
  components: {
    NotFound,
    ObjectLoader,
  },
  props: {
    id: { type: String, required: false },
    redirectRoute: {
      type: String as PropType<RouteNames>,
      default: RouteNames.Agenda,
    },
    value: { type: [Object, null], required: false },
  },
  setup(props) {
    const { id, value, redirectRoute } = toRefs(props);
    const router = inject.router();

    const isObjectVoid = computed(() => !value.value && !id.value);
    watch(
      isObjectVoid,
      (v) => (v ? navigateTo(redirectRoute.value, router) : null),
      { immediate: true }
    );
  },
});
</script>

<style scoped lang="scss">
.loaded {
  width: 100%;
}
</style>
